import { useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useSelection = () => {
  const [collection, setCollection] = useState<number[]>([]);

  const isSelected = (id: number) => collection.includes(id);

  const toggle = (id: number) => {
    setCollection(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // deselect
          : [...prev, id], // select
    );
  };

  const clear = () => setCollection([]);

  const setAll = (ids: number[]) => setCollection(ids);

  return {
    collection,
    isSelected,
    toggle,
    clear,
    setAll,
  };
};
